export enum RosterPositions {
  Center = "C",
  Forward = "F",
  ForwardGuard = "FG",
  ForwardCenter = "FC",
  GuardForward = "GF",

  Guard = "G",
  PowerForward = "PF",
  PointGuard = "PG",
  SmallForward = "SF",
  ShootingGuard = "SG",

  CenterBackcourt = "CB",
  DefensiveSpecialist = "D",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Goalkeeper = "G",
  LeftBackcourt = "LB",
  LeftWingman = "LW",
  Pivot = "P",
  RightBackcourt = "RB",
  RightWingman = "RW",

  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Goalie = "G",
  Skater = "S",

  AttackingMidfield = "AM",
  CentreForward = "CF",
  CentreHalf = "CH",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Defender = "D",
  DefensiveMidfield = "DM",
  FullBack = "FB",
  GoalKeeper = "GK",
  HalfBack = "HB",
  LeftForward = "LF",
  Midfielder = "M",
  Outfielder = "O",
  RightForward = "RF",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Striker = "S",
  Sweeper = "SW",
}
